import React, { useEffect } from 'react'
import posthog, { PostHog } from 'posthog-js'
import { useConfig } from '@context/ConfigurationContext'
import { shouldPosthogTrack } from './PosthogProvider.helper'
import getEnv, { ENV_VARIABLES } from '../../../config'

interface Props {
  children: React.ReactNode
}

const sendInitEvent = (posthog: PostHog) => {
  // This is for the medpress test purpose - remove when test is concluded
  const heroFeatureFlagValue = localStorage.getItem('new-mobile-hero')
  posthog.capture('New hero component displayed', { componentVersion: heroFeatureFlagValue })
}

const PosthogProvider = ({ children }: Props) => {
  const { isInternalClinic, defaultToInternalTracking } = useConfig()

  useEffect(() => {
    if (isInternalClinic === undefined && !defaultToInternalTracking) return

    const shouldTrackInternally =
      isInternalClinic === undefined ?
        defaultToInternalTracking :
        isInternalClinic

    const toolbarJSON = new URLSearchParams(window.location.hash.substring(1)).get('__posthog')
    const apiHost = getEnv(ENV_VARIABLES.POSTHOG_API_HOST)
    const apiKey = getEnv(
      shouldTrackInternally ? ENV_VARIABLES.POSTHOG_INTERNAL_CLINIC_API_KEY : ENV_VARIABLES.POSTHOG_EXTERNAL_CLINIC_API_KEY
    )

    if (!apiKey?.trim?.() || !shouldPosthogTrack()) return

    posthog.init(apiKey, {
      api_host: apiHost,
      opt_in_site_apps: true,
      persistence: 'localStorage',
      loaded: (posthog) => {
        // posthog.debug(true)
        sendInitEvent(posthog)

        if (toolbarJSON) {
          posthog.loadToolbar(JSON.parse(toolbarJSON))
        }
      },
    })
  }, [defaultToInternalTracking, isInternalClinic])

  return <>{children}</>
}

export default PosthogProvider
